import {Colors, createTheme} from '@rn-vui/themed';
import {RecursivePartial} from '@rn-vui/themed/dist/config/theme';

import theme from './theme';

const reactNativeElementsThemeColours: RecursivePartial<Colors> = {
  primary: theme.colour.uiControls.primary,
  secondary: theme.colour.uiControls.secondary,
  disabled: theme.colour.background.button.disabled,
  yellow: theme.colour.background.memberPriceBadge,
  legacy: theme.colour,
  ...theme.colour,
};

export const reactNativeElementsTheme = createTheme({
  ...theme,
  lightColors: reactNativeElementsThemeColours,
  darkColors: reactNativeElementsThemeColours,
  mode: 'light',
});
